import React from "react";
import Slider from "react-slick";
// import useWidth from "../../hooks/useWidth";

export default function ProductLandingGalery({ skuData, product }) {
  // const width = useWidth();

  const settings = {
    dots: true, // This will show dot indicators at the bottom
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  const styleSlider = {
    width: "100%",
    margin: "0 0 1rem 0",
  };

  const sliderStyle = {
    width: "100%", // Set it to 100% to make it expand within its parent
    overflow: "hidden",
  };

  return (
    <div style={styleSlider}>
      {skuData ? (
        <div style={sliderStyle}>
          <Slider {...settings}>
            {skuData.skus[0].skuImages.map((image, index) => (
              <div key={index} className="row-left">
                <div className="marh">
                  <img src={image} alt="beddo" className="w100p" />
                </div>
                <div className="white">c</div>
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <div style={sliderStyle}>
          <Slider {...settings}>
            {product.defaultImages.map((image, index) => (
              <div key={index} className="row-left">
                <div className="marh">
                  <img src={image} alt="beddo" className="w100p" />
                </div>
                <div className="white">c</div>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </div>
  );
}
